/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */

require("./bootstrap")

import "react-calendar/dist/Calendar.css"
import "animate.css"
import "tippy.js/dist/tippy.css"
//import "tw-elements-react/dist/css/tw-elements-react.min.css";  // commented for fixing bug of media-query-not-work
import * as ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"

import store from "./store/store"
import { Provider } from "react-redux"
import { persistStore } from "redux-persist"
import { PersistGate } from "redux-persist/integration/react"
import Default from "./routes"
import MetaPixelEventTracker from "@components/MetaPixel/EventTracker"
import GoogleTagManager from "components/GoogleTagManager"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
    },
  },
})
const persistor = persistStore(store)
ReactDOM.createRoot(document.getElementById("app")).render(
  <QueryClientProvider client={queryClient}>
    <ReactQueryDevtools initialIsOpen={false} />
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <MetaPixelEventTracker />
          <GoogleTagManager />
          <Default />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </QueryClientProvider>
)
